import { get } from "lodash";

export const items = state => state.items.items.items;
export const item = (state, itemId) =>
  get(state, ["items", "items", "item", "byId", itemId]);
export const isFetchingItem = (state, itemId) =>
  get(state, ["items", "items", "fetchingItem", "byId", itemId]);
